import React, { useRef, useState } from 'react';
import classNames from 'classnames';
import Button from 'ac-components/ac-btn';
import Input from 'ac-components/ac-ipt';
import Alert from 'ac-components/alert';
import Select from 'ac-components/select';
import * as Request from '@services/login';
import * as Trace from './trace';
import { formatDate } from '@utils/time-utils';

import styles from './styles.scss';
import { useTranslation } from 'hooks/use-translation';
import AcIcon from 'ac-components/ac-icon';
import globalStore, { GlobalStoreState } from 'states/app';
import { useSelector } from 'react-redux';
import { ConnectState } from 'states/connect';

// 大写字母 小写字母 数字 特殊字符（四种里至少三种）
export const PasswordRegExp = /^(?![a-zA-Z]+$)(?![A-Z0-9]+$)(?![A-Z\W_]+$)(?![a-z0-9]+$)(?![a-z\W_]+$)(?![0-9\W_]+$)[a-zA-Z0-9\W_]{8,20}$/

type Age = {
	id: number;
	name: string;
}

const ageList: Age[] = [];

for (let i = 3; i <= 18; i++) {
	ageList.push({ id: i, name: i + '' })
}
type FillInfoProps = {
	className?: string;
	onFilled(): void;
}
export default function FillInfo(props: FillInfoProps) {
	const { className, onFilled } = props;
	const [name, setName] = useState<string>('');
	const [nameTip, setNameTip] = useState<string>('');
	const [age, setAge] = useState<Age>();
	const [ageTip, setAgeTip] = useState<string>('');
	const [psw, setPsw] = useState<string>('');
	const [pswTip, setPswTip] = useState<string>('');
	const [psw2, setPsw2] = useState<string>('');
	const [psw2Tip, setPsw2Tip] = useState<string>('');
	const [watch, setWatch] = useState<boolean>(false);
	const [alertTip, setAlertTip] = useState<string>('');
	const loadingRef = useRef<boolean>(false);
	const { transData } = useTranslation('login')
	const { user }: GlobalStoreState = useSelector((state: ConnectState) => state.app);

	// 选择年龄
	const onAgeChange = (age: Age) => {
		setAge(age);
		setAgeTip('');
		setAlertTip('');
	}
	// 输入名字
	const onNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		if (e.target.value.trim().length < 100) {
			setName(e.target.value);
		}
		setNameTip('');
		setAlertTip('');
	}
	// 输入密码
	const onPswChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setPsw(e.target.value.trim());
		setPswTip('');
		setAlertTip('');
	}
	// 二次输入密码
	const onPsw2Change = (e: React.ChangeEvent<HTMLInputElement>) => {
		setPsw2(e.target.value.trim());
		setPsw2Tip('');
		setAlertTip('');
	}
	// 查看密码
	const onWatchChange = () => {
		setWatch(!watch);
	}

	// 提交补全个人信息
	const fillInformatiion = async () => {
		console.log(user);
		if (loadingRef.current) return // 提交中
		if (!age) return
		loadingRef.current = true;
		const res = await Request.updateUserInfo({
			newPassWordMsg: psw,
			birthday: formatDate(new Date(new Date().getFullYear() - age.id, 7, 1), 'YYYY-MM-DD'),
			userName: name.trim(),
			email: user?.email // todo 这里需要和服务端沟通，这里应该不需要额外传 email
		})
		loadingRef.current = false;
		if (res.code === Request.ResponseCode.OK && res.data) {
			onFilled();
		} else {
			setAlertTip(res.message);
		}
	}

	// 点击提交
	const onFillInfoSubmit = () => {
		Trace.fillSubmit();
		let fire = true;
		// 校验
		if (!name || !name.trim()) {
			setNameTip(transData.required);
			fire = false;
		}
		if (!age) {
			setAgeTip(transData.required)
			fire = false;
		}
		if (!psw) {
			setPswTip(transData.required);
			fire = false;
		} else if (psw.length < 8) {
			setPswTip(transData.pwsText);
			fire = false;
		} else if (psw.length > 20) {
			setPswTip(transData.pwsText1);
			fire = false;
		}
		if (!psw2) {
			setPsw2Tip(transData.required);
			fire = false;
		}
		if (psw2 && psw && psw !== psw2) {
			setPsw2Tip(transData.pwsText2);
			fire = false;
		}
		if (!fire) return
		fillInformatiion();
	}

	return (
		<div className={classNames(styles.fill_info, styles.card, className)}>
			<h1 className={styles.title}>{transData.information}</h1>
			<div className={styles.alert_wrap}>
				{alertTip && <Alert type='error'>{alertTip}</Alert>}
			</div>
			<div className={styles.item}>
				<div className={styles.label}>{transData.nameText}</div>
				<div className={styles.verify_tip}>{nameTip}</div>
				<Input
					placeholder={transData.nameText}
					onChange={onNameChange}
					value={name}
				/>
			</div>
			<div className={styles.item}>
				<div className={styles.label}>{transData.age}</div>
				<div className={styles.verify_tip}>{ageTip}</div>
				<div>
					<Select
						list={ageList}
						menuTitle={transData.sAge}
						placeholder={transData.ageText}
						allowSearch={false}
						selected={age}
						onChange={onAgeChange}
					/>
				</div>
			</div>
			<div className={styles.item}>
				<div className={styles.label}>
					{transData.psw}
					<span className={styles.tip}>
						<AcIcon icon='icon_info' />
						<div>{transData.pwsText}</div>
					</span>
				</div>
				<div className={styles.verify_tip}>{pswTip}</div>
				<Input
					type={watch ? 'text' : 'password'}
					placeholder={transData.psw}
					onChange={onPswChange}
					value={psw}
					suffix={(
						<AcIcon onClick={onWatchChange}
							className={styles.watch_icon}
							size={24}
							icon={watch ? 'icon_eyeopened' : 'icon_eyeclosed'}
						/>
					)}
				/>
			</div>
			<div className={styles.item}>
				<div className={styles.label}>{transData.pwsText4}</div>
				<div className={styles.verify_tip}>{psw2Tip}</div>
				<Input
					type={watch ? 'text' : 'password'}
					placeholder={transData.pwsText4}
					onChange={onPsw2Change}
					value={psw2}
					suffix={(
						<AcIcon onClick={onWatchChange}
							className={styles.watch_icon}
							icon={watch ? 'icon_eyeopened' : 'icon_eyeclosed'}
							size={24}
						/>
					)}
				/>
			</div>
			<Button onClick={onFillInfoSubmit}>{transData.submit}</Button>
		</div>
	)
}
